import React from 'react'
import { useNavigate } from 'react-router'
import * as s from './TeamProfileHeader.scss'
import { Button } from 'react-bootstrap'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'
import CloudinaryImage from '../../Cloudinary/CloudinaryImage'
import PlayerBackground from './PlayerBackground'

const TeamProfileHeader = ({ playerId = null, profile = null, isMe = false }) => {

    const navigate = useNavigate()

    if (!profile) return null
    const { teamName, division, teamAvatarUrl } = profile || {}
    return (
        <div className={s.teamProfileHeader}>
            <div className={s.identity}>
                <div className={s.avatar}>
                    <CloudinaryImage publicId={teamAvatarUrl} 
                        className={s.avatarImage}
                        transformationName='large_avatar_200' />
                </div>
                <div className={s.infoContainer}>
                    <div className={s.eyebrow}>Team profile</div>
                    <h2 className={s.teamName}>{teamName}</h2>
                    <div className={s.division}>{division} Division</div>
                </div>
                {isMe ? <Button className={s.editButton} variant='light' onClick={() => navigate('/football/edit-team-profile/' + profile._id)}><FontAwesomeIcon name='pencil-alt' /> <span className={s.buttonText}>Edit profile</span></Button> : null}
            </div>
            <PlayerBackground profile={profile} />
        </div>
    )
}

export default TeamProfileHeader
